import { Inject, Injectable, InjectionToken } from '@angular/core';
import { StateService, TargetState, Transition, TransitionService } from '@uirouter/angular';

export const UNSUPPORTED_BROWSER_CONFIGURATION = new InjectionToken<boolean>('unsupportedBrowserConfiguration');

/**
 * This Router service is responsible for intercepting the first transition on our application,
 * verifying if the browser is supported, and redirect to the unsupported browser page if needed,
 * while saving the destination and parameters to provide the user with the link
 */
@Injectable({
  providedIn: 'root'
})
export class UnsupportedBrowserService {
  constructor(private stateService: StateService,
              @Inject(UNSUPPORTED_BROWSER_CONFIGURATION) private isUnsupportedBrowser: boolean) {
  }

  static initHooks(transitionService: TransitionService): void {
    transitionService.onBefore(
      { to: '**' }, (transition: Transition): TargetState | void => {
        const unsupportedBrowserService: UnsupportedBrowserService = transition.injector().get(UnsupportedBrowserService);
        return unsupportedBrowserService.handlePageTransition(transition);
      }, { invokeLimit: 1 });
  }

  private handlePageTransition(transition: Transition): TargetState | void {
    if (this.isUnsupportedBrowser) {
      return this.stateService.target('page.unsupported', { to: transition.to().name, params: transition.params() });
    }
  }
}
